/**
 * Delete adherence post button for Protocol Management
 */
(function( $ ) {
	'use strict';

	//fire funcs when ready
	ready( deleteAdhPostEvent );

	/**
	 * Detect if doc is ready and fire func inside
	 *
	 * @param fn
	 */
	function ready( fn ) {
		if ( document.attachEvent
				? document.readyState === 'complete'
				: document.readyState !== 'loading' ) {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	}

	/**
	 * Click event for deleting adherence post
	 */
	function deleteAdhPostEvent() {
		var deleteAdhBtns = document.querySelectorAll( '.btn-remove-adh' ), i;

		if ( deleteAdhBtns === null ) {
			return;
		}

		for ( i = 0; i < deleteAdhBtns.length; ++i ) {
			deleteAdhBtns[ i ].addEventListener( 'click', function( e ) {
				e.preventDefault();
				passAdhIdFromDeleteBtn( e, this.getAttribute( 'data-adh-id' ) );
			} );
		}
	}

	/**
	 * Function to pass adherence ID to endpoint that deletes post
	 *
	 * @param $adhId
	 */
	function passAdhIdFromDeleteBtn( e, $adhId ) {
		$.ajax( {
			        type   : 'POST',
			        url    : wpApiSettings.root + 'isda/v1/delete-adh-post',
			        data   : {
				        adherence_id: $adhId
			        },
			        success: function( data ) {
//				        console.log( data );
				        //manual refresh for now until we have real time messages for the user
				        window.location.reload();
			        }
		        } );
	}

}
)( jQuery );